"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactI18next = require("react-i18next");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Header = _interopRequireDefault(require("../Header"));
var _Footer = _interopRequireDefault(require("../Footer"));
var _Loader = _interopRequireDefault(require("../Loader"));
var _getCaptureStatus = _interopRequireDefault(require("../../api/Customer/getCaptureStatus"));
var _CaptureForm = _interopRequireDefault(require("./CaptureForm/CaptureForm"));
var _CaptureStyled = require("./CaptureStyled");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const Capture = _ref => {
  let {
    settings,
    onSuccess
  } = _ref;
  const {
    t
  } = (0, _reactI18next.useTranslation)();
  const [captureSettings, setCaptureSettings] = (0, _react.useState)(null);
  const [isLoading, setIsLoading] = (0, _react.useState)(true);
  (0, _react.useEffect)(() => {
    if (settings.length) {
      setCaptureSettings(settings);
      setIsLoading(false);
    } else {
      (0, _getCaptureStatus.default)().then(resp => {
        if (resp.responseData.shouldCaptureBeDisplayed === true) {
          setCaptureSettings(resp.responseData.settings);
          setIsLoading(false);
        } else {
          onSuccess();
        }
      });
    }
  }, []);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_CaptureStyled.CaptureStyled, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Header.default, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_CaptureStyled.CaptureContentStyled, {
      children: isLoading ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Loader.default, {}) : /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_CaptureStyled.CaptureTitle, {
          children: t('Confirm Registration')
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_CaptureForm.default, {
          settings: captureSettings,
          onSuccess: onSuccess
        })]
      })
    }), !isLoading && captureSettings && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Footer.default, {
      isCheckout: false
    })]
  });
};
Capture.propTypes = {
  settings: _propTypes.default.arrayOf(_propTypes.default.any),
  onSuccess: _propTypes.default.func
};
Capture.defaultProps = {
  settings: [],
  onSuccess: () => {}
};
var _default = exports.default = Capture;